module.exports = __webpack_public_path__ + "static/img/weibo.4be92f1e.png";